/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { action, makeObservable, observable } from 'mobx';

type PanelRenderer = (hide: () => void) => React.ReactNode;

export class PageDialogStore {
    @observable loading = false;
    @observable pending = false;
    @observable isPanelOpened = false;

    panelRenderer: PanelRenderer;

    constructor() {
        makeObservable(this);
    }

    @action.bound
    openPanel(panelRenderer: PanelRenderer): void {
        this.panelRenderer = panelRenderer;
        this.isPanelOpened = true;
    }

    @action.bound
    closePanel(): void {
        this.isPanelOpened = false;
    }

    @action.bound
    setLoading(loading: boolean): void {
        this.loading = loading;
    }

    @action.bound
    setPending(pending: boolean): void {
        this.pending = pending;
    }
}
